import { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { useAppDispatch, useAppSelector } from "../../../lib/redux/hooks";
import { GetFileObjectById } from "../../../objectStorage/slice";
import { colors } from "../../../ui/colors";
import { EditIcon } from "../../../ui/icons/edit";
import { Sort } from "../../../ui/icons/sort";
import { entryMeansOptions, formatterDate, optionsFormatter } from "../../../utils";
import { EntryProtocolDTO } from "./dataService/dto";
import { GetAllEntryProtocols, resetGetAllEntryProtocolsStatus, setEntryProtocolIdToUpdate, setGetAllEntryProtocolOrderFilter, setGetAllEntryProtocolSortFilter, setSelectedProtNumber, setUpdatedEPFileAndAtt, setUpdatedFile, setUpdateEPCustomerIds, setUpdateEPCustomersNotRegistered, setUpdateEPDestinationOffice, setUpdateEPEntryAttachmentIds, setUpdateEPEntryChannel, setUpdateEPEntryObjectId, setUpdateEPHeadquarter, setUpdateEPLinkExistingProtocol, setUpdateEPNation, setUpdateEPObjectSpec, setUpdateEPProtocolDate, setUpdateEPRegion, setUpdateEPSend, setUpdateEPSender, setUpdateEPTotalPage, setUpdateEPUsersVisibility } from "./slice";


export function EntryListProtocol() {
    const navigate = useNavigate()

    const dispatch = useAppDispatch()
    const entryProtocolState = useAppSelector(state => state.entryProtocol)
    const objectStorageState = useAppSelector(state => state.objectStorage)

    const handleOnEdit = (data: EntryProtocolDTO) => {
        dispatch(setEntryProtocolIdToUpdate(data.id))
        dispatch(setUpdateEPHeadquarter(data.headQuarter))
        dispatch(setUpdateEPProtocolDate(data.protocolDate))
        dispatch(setUpdateEPNation(data.nation))
        dispatch(setUpdateEPRegion(data.region))
        dispatch(setUpdateEPSender(data.sender))
        if (data.customersInfo !== null)
            dispatch(setUpdateEPCustomerIds(data.customersInfo.map(c => c.id)))
        dispatch(setUpdateEPCustomersNotRegistered(data.customersNotRegistered))
        dispatch(setUpdateEPEntryObjectId(data.entryObject.id))
        dispatch(setUpdateEPObjectSpec(data.objectSpec))
        dispatch(setUpdateEPTotalPage(data.totalPage))
        dispatch(setUpdateEPEntryChannel(data.entryChannel))
        dispatch(setUpdateEPSend(data.send))
        dispatch(setUpdateEPUsersVisibility(data.usersVisibility))
        dispatch(setUpdateEPLinkExistingProtocol(data.linkExistingProtocol))
        dispatch(setUpdateEPDestinationOffice(data.destinationOffice))
        dispatch(setUpdateEPEntryAttachmentIds(data.entryAttachments.map(a => a.id)))
        dispatch(setSelectedProtNumber(data.headQuarter + ' E' + data.protocolNumber + " del " + formatterDate(data.protocolDate)))
        if (data.fileId !== null && data.fileId !== undefined) {
            dispatch(GetFileObjectById(data.fileId))
        }
        dispatch(setUpdatedEPFileAndAtt(data.attachmentFile))
        navigate('/editEntryProtocol')
    }

    useEffect(() => {
        if (objectStorageState.getFileObjectByIdStatus === 'successfully') {
            dispatch(setUpdatedFile(objectStorageState.getFileObjectByIdResponse))
        }

    }, [objectStorageState.getFileObjectByIdStatus])

    // useEffect(() => {
    //     dispatch(GetAllEntryProtocols(entryProtocolState.getAllEntryProtocolFilters))
    // }, [])

    useEffect(() => {
        if (entryProtocolState.getAllEntryProtocolsStatus === 'successfully') {
            dispatch(resetGetAllEntryProtocolsStatus())
        }
    }, [entryProtocolState.getAllEntryProtocolsStatus])

    useEffect(() => {
        dispatch(GetAllEntryProtocols({ ...entryProtocolState.getAllEntryProtocolFilters, sort: entryProtocolState.getAllEntryProtocolFilters.sort, order: entryProtocolState.getAllEntryProtocolFilters.order }))
    }, [entryProtocolState.getAllEntryProtocolFilters.sort, entryProtocolState.getAllEntryProtocolFilters.order])

    const sortableCols: { label: string; field: string }[] = [
        { label: 'Numero', field: 'protocolNumber' },
        { label: 'Sede', field: 'headQuarter' },
        { label: 'Anno', field: 'year' },
        { label: 'Data', field: 'protocolDate' },
        { label: 'Mittente', field: 'sender' },
        { label: 'Cliente', field: 'customer' },
        { label: 'Oggetto', field: 'entryObject' },
        { label: 'Oggetto Extra', field: 'objectSpec' },
        { label: 'Mezzo Entrata', field: 'entryChannel' },
        { label: 'Funzionario', field: 'user' },
    ]

    const SortableTh = ({ label, onSort }: { label: string; onSort?: () => void }) => (
        <th className="px-3 py-3 text-left font-semibold whitespace-nowrap">
            <div className="flex flex-row items-center gap-1 w-full">
                {label}
                <Sort size={14} color={colors.white} onClick={() => onSort && onSort()} />
            </div>
        </th>
    )

    return (
        <div className="w-full px-6 pb-6i">
            <div className="w-full overflow-x-auto rounded-xl border border-neutral-200 shadow-sm">
                <table id="users-table" className="w-full border-collapse text-sm">
                    <thead>
                        <tr className="bg-brandPrimary-600 text-white uppercase text-xs tracking-wide h-[52px]">
                            {sortableCols.map((col) => (
                                <SortableTh
                                    key={col.label}
                                    label={col.label}
                                    onSort={() => {
                                        dispatch(setGetAllEntryProtocolSortFilter(col.field))
                                        dispatch(setGetAllEntryProtocolOrderFilter(entryProtocolState.getAllEntryProtocolFilters.order === true ? false : true))
                                    }}
                                />
                            ))}
                            <th className="px-3 py-3 text-left font-semibold whitespace-nowrap">Allegati</th>
                            <th className="px-3 py-3 text-center font-semibold whitespace-nowrap rounded-tr-xl w-[40px]" />
                        </tr>
                    </thead>
                    <tbody>
                        {entryProtocolState.getAllEntryProtocolsResponse?.data?.map((protocol, index) => (
                            <tr
                                key={index}
                                className={`border-b border-neutral-200 transition-colors duration-150 hover:bg-brandPrimary-50 ${index % 2 === 0 ? 'bg-white' : 'bg-neutral-50'}`}
                            >
                                <td className="px-3 py-2 text-neutral-700 whitespace-nowrap font-semibold">{protocol.headQuarter} {'E' + protocol.protocolNumber}</td>
                                <td className="px-3 py-2 text-neutral-700 whitespace-nowrap">{protocol.headQuarter}</td>
                                <td className="px-3 py-2 text-neutral-700 whitespace-nowrap">{protocol.year}</td>
                                <td className="px-3 py-2 text-neutral-700 whitespace-nowrap text-xs">{formatterDate(protocol.protocolDate)}</td>
                                <td className="px-3 py-2 text-neutral-700">{protocol.sender}</td>
                                <td className="px-3 py-2 text-neutral-700 min-w-[160px]">
                                    {protocol.customersInfo?.map((customer, i, arr) => (
                                        <span key={i}>{customer.companyName}{i < arr.length - 1 && ', '}</span>
                                    ))}
                                </td>
                                <td className="px-3 py-2 text-neutral-700">{protocol.entryObject.description}</td>
                                <td className="px-3 py-2 text-neutral-700">{protocol.objectSpec}</td>
                                <td className="px-3 py-2 text-neutral-700 whitespace-nowrap">{protocol.entryChannel && optionsFormatter(protocol.entryChannel, entryMeansOptions)}</td>
                                <td className="px-3 py-2 text-neutral-700 whitespace-nowrap">{`${protocol.user.name} ${protocol.user.surname}`}</td>
                                <td className="px-3 py-2 text-neutral-700 min-w-[140px]">
                                    {protocol.entryAttachments.map((att, i, arr) =>
                                        i < arr.length - 1 ? `[${att.coding}] - ` : `[${att.coding}]`
                                    )}
                                </td>
                                <td className="px-3 py-2 w-[40px] text-center">
                                    <button
                                        className="relative group p-1 rounded hover:bg-neutral-100 transition-colors"
                                        onClick={() => handleOnEdit(protocol)}
                                        aria-label="Modifica protocollo"
                                        title="Modifica protocollo"
                                    >
                                        <EditIcon color="Orange" size={18} />
                                        <span className="absolute bottom-full right-0 mb-1 hidden group-hover:block px-2 py-1 text-xs text-white bg-neutral-800 rounded whitespace-nowrap pointer-events-none z-10">
                                            Modifica Protocollo
                                        </span>
                                    </button>
                                </td>
                            </tr>
                        ))}
                    </tbody>
                </table>
            </div>
        </div>
    )
}